import {numberWithCommas} from "../../common";
import React, {useEffect, useMemo, useState} from "react";
import DailyFullReportExpRow, {ExpenceType} from "./DailyFullReportExpRow";

interface Props {
    exp_type: "bank" | "cash";
    formValues: Map<string, any>;
    setFormValues: (fv: Map<string, any>) => void;
    exp_types: Array<ExpenceType>,
    isBgnMode: boolean;
    currencyRate: number;
    currencyName: string;
}

const DailyFullReportExpences = ({
                                     exp_type,
                                     formValues,
                                     setFormValues,
                                     exp_types,
                                     isBgnMode,
                                     currencyRate,
                                     currencyName,
                                 }: Props) => {
    const [fv, setFV] = useState(formValues);
    useEffect(() => {
        // formValues.forEach(
        //     (value, key) => {
        //         if (!key.includes(exp_type)) {
        //             fv.set(key, value);
        //         }
        //     }
        // );
        setFV(formValues);
    }, [formValues]);

    const calculateExpenseTotal = (formValues: Map<string, any>) => {
        let total = 0;
        for (let i = 0; i < 50; i++) {
            let value = formValues.get(`${exp_type}_expense_amount_${i}`);
            if (value) {
                total += value * 1;
            }
        }
        total += formValues.get(`${exp_type}_palet_price`) * 1;
        const convertedTotal = total * currencyRate;
        return numberWithCommas(convertedTotal.toFixed(2)) + ' ' + currencyName;
    }

    const removeRow = (idx: number) => {
        const newFV = new Map(fv);

        newFV.set(`${exp_type}_expense_description_${idx}`, "");
        newFV.set(`${exp_type}_expense_qty_${idx}`, 0);
        newFV.set(`${exp_type}_expense_amount_${idx}`, 0);
        newFV.set(`${exp_type}_expense_has_vat_${idx}`, false);

        for (let i = idx; i < 49; i++) {
            newFV.set(`${exp_type}_expense_description_${i}`, fv.get(`${exp_type}_expense_description_${i + 1}`) ?? "");
            newFV.set(`${exp_type}_expense_qty_${i}`, fv.get(`${exp_type}_expense_qty_${i + 1}`) ?? "");
            newFV.set(`${exp_type}_expense_amount_${i}`, fv.get(`${exp_type}_expense_amount_${i + 1}`) ?? "");
            newFV.set(`${exp_type}_expense_has_vat_${i}`, fv.get(`${exp_type}_expense_has_vat_${i + 1}`) ?? false);
        }

        let isFirst = true;
        for (let i = 0; i < 50; i++) {
            if (!newFV.get(`${exp_type}_expense_description_${i}`)
                && !newFV.get(`${exp_type}_expense_qty_${i}`)
                && !newFV.get(`${exp_type}_expense_amount_${i}`)) {
                if (!isFirst) {
                    newFV.delete(`${exp_type}_expense_description_${i}`);
                    newFV.delete(`${exp_type}_expense_qty_${i}`);
                    newFV.delete(`${exp_type}_expense_amount_${i}`);
                    newFV.delete(`${exp_type}_expense_has_vat_${i}`);
                } else {
                    isFirst = false;
                }
            }
        }
        return newFV;
    }

    const updateFormValues = (fv: Map<string, any>) => {
        setFV(fv);
        setFormValues(fv);
    }

    const generateBankExpRow = (idx: number) => {
        return <DailyFullReportExpRow
            key={`${exp_type}_bank_exp_${idx}`}
            exp_types={exp_types}
            record={{
                recordType: "exp",
                description: fv.get(`${exp_type}_expense_description_${idx}`),
                qty: fv.get(`${exp_type}_expense_qty_${idx}`),
                price: fv.get(`${exp_type}_expense_amount_${idx}`),
                hasVat: fv.get(`${exp_type}_expense_has_vat_${idx}`),
            }}
            onchange={(record) => {
                const newFV = new Map(fv);
                newFV.set(`${exp_type}_expense_description_${idx}`, record.description);
                newFV.set(`${exp_type}_expense_qty_${idx}`, record.qty);
                newFV.set(`${exp_type}_expense_amount_${idx}`, record.price);
                newFV.set(`${exp_type}_expense_has_vat_${idx}`, record.hasVat);
                updateFormValues(newFV);
            }}
            onRemove={() => {
                const newFV = removeRow(idx);
                updateFormValues(newFV);
            }}
            isBgnMode={isBgnMode}
            currencyRate={currencyRate}
        />
    }

    const bankExpRows = useMemo(() => {
        const bankExpRows = [];
        for (let idx = 0; idx < 50; idx++) {
            if (fv.get(`${exp_type}_expense_description_${idx}`)) {
                bankExpRows.push(generateBankExpRow(idx));
            }
        }
        bankExpRows.push(generateBankExpRow(bankExpRows.length));
        return bankExpRows;
    }, [fv, currencyRate, isBgnMode]);

    return (

        <table className={"table table-sm table-bordered "}>
            <tr className={"text-center"}>
                <td className={"w-480px"}><strong>Описание</strong></td>
                <td className={"w-75px"}><strong>К-во</strong></td>
                <td className={"w-75px"}><strong>Сума({currencyName})</strong></td>
                <td className={"w-35px fw-bold"} colSpan={2}>Ф-ра?</td>
            </tr>
            {
                bankExpRows
            }
            <tr className={"text-end"}>
                <td className={"text-end"} colSpan={3}><strong>Всичко</strong></td>
                <td colSpan={2}><strong>{calculateExpenseTotal(fv)}</strong></td>
            </tr>
            <tr className={"text-start"}>
                <td colSpan={4}>
                    <strong>Забележки:</strong>
                    <textarea
                        className={"form-control form-control-sm"}
                        value={fv.get(`${exp_type}_expense_notes`) ?? ""}
                        disabled={isBgnMode}
                        onChange={(e) => {
                            const newFV = new Map(fv);
                            newFV.set(`${exp_type}_expense_notes`, e.target.value);
                            updateFormValues(newFV);
                        }}
                    />
                </td>
            </tr>
        </table>
    )
}

export default DailyFullReportExpences


